/* eslint-disable no-undef */

import { authGet, get, getSavedUser, pubGet, pubJsonGet } from "functions/BaseAxios";
import { countryJQL, featuredCountryJQL } from "functions/JQL/ListingJQL";

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRIES_HOME = 'GET_COUNTRIES_HOME';
export const FEATURED_COUNTRIES = 'FEATURED_COUNTRIES';
export const COMMISSION_SETTING = 'COMMISSION_SETTING';

export const getCommissionSetting = () => {
  return async (dispatch: DispatchType) => {
    var data = await pubJsonGet({
      setting: [
        'customerFee',
        'isCustomerFeePercent',
        'guideFee',
        'isGuideFeePercent',
        'addServiceFee',
        'addServiceFeePercent',
      ],
    });
    dispatch({
      type: COMMISSION_SETTING,
      payload: data.code == 200 ? data.payload.setting[0] : [],
    });
  };
};

function extractArrayFromResponse(data: any): any[] {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.payload?.data)) return data.payload.data;
  if (Array.isArray(data.payload?.country)) return data.payload.country;
  if (Array.isArray(data.payload)) return data.payload;
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(data.message)) return data.message;
  if (data.payload && typeof data.payload === 'object') {
    for (const k of Object.keys(data.payload)) {
      if (Array.isArray(data.payload[k])) return data.payload[k];
    }
  }
  return [];
}

export const getHomeCountries = () => {
  return async (dispatch: DispatchType) => {
    try {
      var data = await pubGet("countries");
      let payloadData = extractArrayFromResponse(data);
      if (payloadData.length === 0) {
        var fallbackData = await pubJsonGet(countryJQL);
        payloadData = extractArrayFromResponse(fallbackData);
      }
      dispatch({
        type: GET_COUNTRIES_HOME,
        payload: payloadData,
      });
    } catch (err) {
      dispatch({
        type: GET_COUNTRIES_HOME,
        payload: [],
      });
    }
  };
};

export const getCountries = () => {
  return async (dispatch: DispatchType) => {
    try {
      var data = await pubJsonGet(countryJQL);
      let payloadData = extractArrayFromResponse(data);
      if (payloadData.length === 0) {
        var fallbackData = await pubGet("countries");
        payloadData = extractArrayFromResponse(fallbackData);
      }
      dispatch({
        type: GET_COUNTRIES,
        payload: payloadData,
      });
    } catch (err) {
      dispatch({
        type: GET_COUNTRIES,
        payload: [],
      });
    }
  };
};

export const getCountriesToAdd = () => {
  return async (dispatch: DispatchType) => {
    var data = await authGet('auth/countries-add');
    dispatch({
      type: GET_COUNTRIES,
      payload: data.code !== 200 ? [] : data.payload.country,
    });
  };
};

export const getFeaturedCountries = () => {
  return async (dispatch: DispatchType) => {
    var data = await pubJsonGet(featuredCountryJQL);
    dispatch({
      type: FEATURED_COUNTRIES,
      payload: data.code !== 200 ? [] : data.payload.country,
    });
  };
};

export async function getCountryByCode(code: string) {
  var data = await get('api/countries/' + code);
  return data.payload.data;
}